import React from 'react';
import './Event_about.css';

const FAQ = () => {
    const state = {
        About_item: [
            {
                num: '01.',
                text: `Hardhat, Truffle, Brownie - discover Web3 development environments for Javascript and Python`,
            },
            {
                num: '02.',
                text: `Scalability of blockchain with Layer 2.0`,
            },
            {
                num: '03.',
                text: `NEAR - Layer 1 using Rust or Assemblyscript for smartcontracts`,
            },
            {
                num: '04.',
                text: `Сreation and development of frontend components for WEB3: Ether.js and Web3.js, oo7.js, Alchemy Web3`,
            },
            {
                num: '05.',
                text: `Solana - Layer 1 using Rust C, C++ for smartcontracts`,
            },
            {
                num: '06.',
                text: `Testing for blockchain`,
            },
            {
                num: '07.',
                text: `Cross-chain bridges - challenges of moving cross-chain`,
            },
            {
                num: '08.',
                text: `Ethereum scaling solutions: Polygon, Arbitrum, Immutable X`,
            },
            {
                num: '09.',
                text: `Safety audit of smart contracts`,
            },
            {
                num: '10.',
                text: `Tokenomics - How to design token models that help to grow network`,
            },
        ],
    };

    const renderAboutItem = (item, i) => {
        return (
            <div className="about_item" key={`about-item-${i + item.text}`}>
                <p className="about_num">{item.num}</p>
                <p className="about_text"> {item.text}</p>
            </div>
        );
    };

    return (
        <div className="about_wrap">
            <div className="about container">
                <h3 className="about_title">What is the event about?</h3>
                <div className="about_blocks">
                    {state.About_item.map((item, i) => renderAboutItem(item, i))}
                </div>
            </div>
        </div>
    );
};

export default FAQ;